import { useCallback, useMemo } from 'react';
import { accountsHealthFactorAtom, activeAccountIdAtom, walletAddressAtom } from '../../../../atoms';
import { useAtom } from '../../../../lib';

import './LiquidationRiskBanner.scss';
import { Decimal } from '../../../../datastructures';
import { Icon, Typography } from '../../../shared';
import { DecimalFormat } from '@tempusfinance/decimal';
import { setActiveAccount } from '../../../../atoms/lendAndBorrow/activeAccountIdAtom';
import { HEALTH_FACTOR_DANGER } from '../../../../constants';

const LiquidationRiskBanner = () => {
  const [accountsHealthFactor] = useAtom(accountsHealthFactorAtom);
  const [activeAccountId] = useAtom(activeAccountIdAtom);
  const [walletAddress] = useAtom(walletAddressAtom);

  const riskyAccounts = useMemo(() => {
    const result: { healthFactor: Decimal; accountName: string; accountId: number }[] = [];

    Object.entries(accountsHealthFactor).forEach(([, healthFactorData]) => {
      if (healthFactorData.value.lt(HEALTH_FACTOR_DANGER)) {
        result.push({
          healthFactor: healthFactorData.value,
          accountName: healthFactorData.accountName,
          accountId: healthFactorData.accountId,
        });
      }
    });

    return result;
  }, [accountsHealthFactor]);

  const onSwitch = useCallback(() => {
    if (!walletAddress) {
      return null;
    }

    setActiveAccount(walletAddress, riskyAccounts[0].accountId);
  }, [riskyAccounts, walletAddress]);

  if (!riskyAccounts.length) {
    return null;
  }

  return (
    <div className="nostra__liquidationRiskBanner">
      <div className="nostra__liquidationRiskBanner__label">
        <Icon variant="exclamation" size={20} color="--icon-default-darkbg" />
        <Typography variant="body-md" color="text-primary-darkbg">
          <strong>Urgent: </strong> Your health factor{' '}
          {riskyAccounts.map((riskyAccount, index) => {
            const healthFactorFormatted = DecimalFormat.format(riskyAccount.healthFactor, {
              style: 'decimal',
              fractionDigits: 2,
              pad: true,
            });

            if (riskyAccounts.length === 1) {
              return (
                <span key={riskyAccount.accountId}>
                  for <strong>{riskyAccount.accountName}</strong> is {healthFactorFormatted}
                </span>
              );
            } else if (index < riskyAccounts.length - 1) {
              return (
                <span key={riskyAccount.accountId}>
                  for <strong>{riskyAccount.accountName}</strong> is {healthFactorFormatted}{' '}
                </span>
              );
            } else {
              return (
                <span key={riskyAccount.accountId}>
                  and for <strong>{riskyAccount.accountName}</strong> is {healthFactorFormatted}
                </span>
              );
            }
          })}
          . Add collateral or {'(partially)'} repay your debt to avoid liquidation.
        </Typography>
      </div>
      {riskyAccounts[0].accountId !== activeAccountId && (
        <div className="nostra__liquidationRiskBanner__button" onClick={onSwitch}>
          <Typography variant="button-sm" color="text-primary-darkbg" weight="semi-bold">
            Switch to {riskyAccounts[0].accountName}
          </Typography>
          <Icon variant="arrow-right" size={16} color="--icon-default-darkbg" />
        </div>
      )}
    </div>
  );
};
export default LiquidationRiskBanner;
